import type { FormatStrings } from "@skilitics/localization";

import publishImgUrl from "./DistributeWizardThumbnail.webp";

export type FeatureName = "publish" | "saveTemplates";

export type UpgradePrompt = {
  imgUrl?: string;
  title: FormatStrings;
  description: FormatStrings;
};

export const upgradePrompts: Record<FeatureName, UpgradePrompt> = {
  publish: {
    imgUrl: publishImgUrl,
    title: {
      en: "Ship your training to any audience!",
    },
    description: {
      en: "Publish takes a snapshot of your module, then allows you to select, package and distribute any snapshot from your library using settings tailored to different audiences - all without rebuilding!",
    },
  },
  saveTemplates: {
    title: {
      en: "Build it once, reuse it everywhere!",
    },
    description: {
      en: "Saving templates allows you to capture any activity, widget, overlay or frame you've built, then allows you to tag, categorize and reuse it from your library in any module - saving you time and effort when building new modules!",
    },
  },
};
